import { render, staticRenderFns } from "./designated-send.vue?vue&type=template&id=0298c67d&scoped=true"
import script from "./designated-send.vue?vue&type=script&lang=js"
export * from "./designated-send.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298c67d",
  null
  
)

export default component.exports